export const GET_AVAILABILITY_STORES_START = 'GET_AVAILABILITY_STORES_START';

export const GET_AVAILABILITY_STORES_SUCCESS = 'GET_AVAILABILITY_STORES_SUCCESS';

export const GET_AVAILABILITY_STORES_FAILED = 'GET_AVAILABILITY_STORES_FAILED';

export const TOGGLE_GET_AVAILABILITY_STORES_LOADING = 'TOGGLE_GET_AVAILABILITY_STORES_LOADING';